/**
 * Client-side API functions for MegaMenu components
 * These use the Next.js API routes for client-side data fetching
 */

/**
 * Get popular blog articles for MegaMenu
 * Uses the /api/articles endpoint with appropriate filters
 */
export const getPopularBlogForMegaMenu = async () => {
  const response = await fetch('/api/articles?_exact[audience_shortcode]=b2b&_exact[article_type_slug]=blog&_exact[article_popular]=Y');

  if (!response.ok) {
    throw new Error(`Error ${response.status}: Failed to fetch popular blogs`);
  }

  return await response.json();
};

/**
 * Get limited upcoming events for MegaMenu
 * Uses the /api/events endpoint with appropriate filters
 * @param {number} limit - Maximum number of events to return
 */
export const getLimitedUpcomingEvents = async (limit) => {
  const response = await fetch(`/api/events?_cond[event_featured]=Y&event_status=upcoming&_order[event_date]=DESC&_limit[row]=0&_limit[max]=${limit}`);

  if (!response.ok) {
    throw new Error(`Error ${response.status}: Failed to fetch limited upcoming events`);
  }

  return await response.json();
};
